export var DateStatus;
(function (DateStatus) {
    /** 在当前日期之前 */
    DateStatus[DateStatus["before"] = 0] = "before";
    /** 在当前日期期间 */
    DateStatus[DateStatus["ing"] = 1] = "ing";
    /** 在当前日期以后 */
    DateStatus[DateStatus["after"] = 2] = "after";
})(DateStatus || (DateStatus = {}));
